import { Paper, Stack, Text } from "@mantine/core";

import classes from "./UserMessage.module.css";
import { useTranslation } from "react-i18next";

export interface UserMessageProps {
    message: string;
}
export const UserMessage = ({ message }: UserMessageProps) => {
    const { t } = useTranslation();
    return (
        <Stack align="flex-end" justify="center" gap="xs">
            <Paper shadow="xs" radius="xl" className={classes.userMessageContainer}>
                <Text>{message}</Text>
            </Paper>
        </Stack>
    );
};
